'use strict';

module.exports = typeof Promise === 'function' ? Promise : require('pinkie');



//////////////////
// WEBPACK FOOTER
// ./~/pinkie-promise/index.js
// module id = 591
// module chunks = 0